import AccountDeletion from '@/api/peg/accountDeletion'
import AppReturnReasons from '@/api/peg/appReturnReasons'
import AuctionItems from '@/api/peg/auctionItems'
import AuctionItemBids from '@/api/peg/auctionItemBids'
import Auth from '@/api/peg/auth'
import Businesses from '@/api/peg/businesses'
import Cart from '@/api/peg/cart'
import Categories from '@/api/peg/categories'
import Checkout from '@/api/peg/checkout'
import CityState from '@/api/peg/cityState'
import Onboarding from '@/api/peg/onboarding'
import NotificationPreferences from '@/api/peg/notificationPreferences'
import AdminDashboard from '@/api/peg/adminDashboard'
import ReportingAgent from '@/api/peg/reportingAgent'
import SupportContacts from '@/api/peg/supportContacts'
import Orders from '@/api/peg/orders'
import PaymentGateway from '@/api/peg/paymentGateway'
import Retailers from '@/api/peg/retailers'
import ReturnSessions from '@/api/peg/returnSessions'
import ReturnSessionItems from '@/api/peg/returnSessionItems'
import ReturnSessionDynamicQuestions from '@/api/peg/returnSessionDynamicQuestions'
import ReturnSessionItemsBoxes from '@/api/peg/returnSessionItemsBoxes'
import ReturnSessionMedia from '@/api/peg/returnSessionMedia'
import Search from '@/api/peg/search'
import Users from '@/api/peg/users'

/**
 * PegApi
 * @category Boot
 * @module PegApi
 * @description API for Peg-related operations
 */

export const $pegApi = {
  AccountDeletion,
  AppReturnReasons,
  AuctionItems,
  AuctionItemBids,
  Auth,
  Businesses,
  Cart,
  Categories,
  Checkout,
  CityState,
  Onboarding,
  NotificationPreferences,
  AdminDashboard,
  ReportingAgent,
  SupportContacts,
  Orders,
  PaymentGateway,
  Retailers,
  ReturnSessions,
  ReturnSessionItems,
  ReturnSessionDynamicQuestions,
  ReturnSessionItemsBoxes,
  ReturnSessionMedia,
  Search,
  Users,
}
